import { Button } from "antd";
import { KeyOutlined } from "@ant-design/icons";
import GoogleIcon from "../../assets/auth/google.svg";
import MicrosoftIcon from "../../assets/auth/microsoft.svg";
import "./auth-alternative-actions.css";

export default function AuthAlternativeActions({
  disabled,
  onGoogle,
  onMicrosoft,
  onPasskey,
  showGoogle = true,
  showMicrosoft = true,
  showPasskey = true,
}) {
  const hasAny = showGoogle || showMicrosoft || showPasskey;

  if (!hasAny) return null;

  return (
    <div className="auth-alt">
      <div className="auth-alt__divider">
        <span>or</span>
      </div>

      <div className="auth__body">
        <div className="auth-alt__buttons">

          {showGoogle && (
            <Button
              className="auth-alt__btn auth-alt__btn--google"
              size="large"
              disabled={disabled}
              onClick={onGoogle}
              icon={<img src={GoogleIcon} alt="" className="auth-alt__icon" />}
            >
              Continue with Google
            </Button>
          )}

          {showMicrosoft && (
            <Button
              className="auth-alt__btn auth-alt__btn--microsoft"
              size="large"
              disabled={disabled}
              onClick={onMicrosoft}
              icon={<img src={MicrosoftIcon} alt="" className="auth-alt__icon" />}
            >
              Continue with Microsoft
            </Button>
          )}

          {showPasskey && (
            <Button
              className="auth-alt__btn auth-alt__btn--passkey"
              size="large"
              disabled={disabled}
              onClick={onPasskey}
              icon={<KeyOutlined />}
            >
              Use Passkey
            </Button>
          )}

        </div>
      </div>
    </div>
  );
}